import type { TrialInvite } from "../../../services/trialInviteApi";
import { formatDateTime } from "./formatDateTime";

/**
 * Tells invites apart in accessible names and dialogs: by e-mail, else by
 * creation time ("dla a@b.pl" / "z 30.09.2026, 12:00").
 */
export const inviteContext = (invite: TrialInvite): string =>
  invite.email ? `dla ${invite.email}` : `z ${formatDateTime(invite.createdAt)}`;
